const initialState = {
	isFetchingCart: false,
	isRemovingItem: false,
	isApplyingDiscount: false,
	isApplyingGiftCard: false,

	error: null,
	applyDiscountError: null,
	applyGiftCardError: null,

	settings: {},
	misc: {
		appliedDiscounts: [],
		appliedGiftCards: [],
	},

	cartQuantity: 0,
	orderTotals: {},
	entities: {
		items: {},
	},

	checkoutAttributes: [],
	result: [],
}

export default initialState
